import { ContactProvider } from '@/modules/contato'
import Page from '@/modules/contato/pages/index.page'

Page.FlowProvider = ContactProvider

export default Page
